import React from "react";
import { useParams } from "react-router-dom";
import InvoiceViewer from "../components/InvoiceViewer";

interface Props {
  token: string;
}

const InvoiceViewerRoute: React.FC<Props> = ({ token }) => {
  const { id } = useParams<{ id: string }>();
  return <InvoiceViewer token={token} invoiceId={id} />;
};

export default InvoiceViewerRoute;
